import React from 'react';
import { get } from 'lodash/fp';
import { connect } from 'react-redux';
import { Icon } from 'ui';
import * as selectors from 'selectors/pathBuilder';
import * as actions from 'actions/pathBuilder';
import ContentSharing from 'components/shared/ContentSharing';
import Section, { SectionHeader } from './Section';

const Sharing = ({
  editing,
  isArchived,
  isPublic,
  onOptionChange,
  shareUrl,
  toggleEditing,
  changePublicitySettings,
  isCertification,
  features,
}) => (
  <Section>
    <SectionHeader className="d-f jc-sb">
      {t('common.sharing')}
      {!isArchived && !editing && changePublicitySettings && (
        <button
          type="button"
          className="u-linkBtn fz-base fw-n"
          onClick={toggleEditing}
        >
          <Icon name="edit" className="mr-4" />
          {t('actions.edit')}
        </button>
      )}
    </SectionHeader>
    <ContentSharing
      editing={editing}
      toggleEditing={toggleEditing}
      public={isPublic}
      shareUrl={shareUrl}
      onOptionChange={onOptionChange}
      typeName={isCertification ? t('certifications.certifications') : 'Path'}
    />
  </Section>
);

const UI_STATE_KEY = 'sharing';

const mapStateToProps = ({ pathBuilder, ...state }) => ({
  editing: selectors.isEditingUIElementByName(pathBuilder, UI_STATE_KEY),
  isArchived: selectors.isArchived(pathBuilder),
  shareUrl: get('urls.share')(pathBuilder),
  isPublic: pathBuilder.public,
  changePublicitySettings: pathBuilder.permissions.changePublicitySettings,
  isCertification: !!get('certification')(pathBuilder),
});

const mapDispatchToProps = {
  toggleEditing: actions.toggleEditingUIElementByName.bind(null, UI_STATE_KEY),
  onOptionChange: actions.updatePathPublicity,
};

export default connect(mapStateToProps, mapDispatchToProps)(Sharing);
